<div
  *ngIf="!(leg?.flightStatus | jbIncludesSubstring: 'TROUBLE')"
  [ngClass]="{
    'fl pv1 b core-blue relative pr3 pl3': true,
    'status-column dn db-ns': useStatusColumnCSS
  }"
>
  <span class="clip">{{
    (flightTrackerText$ | async)?.tabletStickyStatus
  }}</span>
  <span class="{{ setStatusColor(leg?.flightStatus) }}">&#9679; </span>
  <span>{{
    leg?.flightStatus
      | dotCapitalizeFlightStatus: originAndDestinationAirport : diversion
  }}</span>
  <div>
    <jb-icon
      *ngIf="leg?.flightStatus | jbIncludesSubstring: 'MINT'"
      class="pl1 fill-mint-green"
      name="mintIndicator"
      width="1.5em"
      height="1.5em"
    ></jb-icon>
    <jb-icon
      name="mosaicFullColor"
      *ngIf="leg?.flightStatus | jbIncludesSubstring: 'MOSAIC'"
      class="pl1"
    ></jb-icon>
  </div>
  <jb-icon
    name="emsLogo"
    *ngIf="leg?.flightStatus | jbIncludesSubstring: 'GROUP A'"
    class="pl1"
  ></jb-icon>
</div>
